class FalcoProduct extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
    this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    this.current = 0;
    this.form = this.querySelector('[data-product-form]');
    this.variantInput = this.querySelector('[data-variant-id]');
    this.paidSelect = this.querySelector('[data-paid-variant]');
    this.freeSelect = this.querySelector('[data-free-color]');
    this.submit = this.querySelector('[data-main-submit]');
    this.sticky = this.querySelector('[data-mobile-sticky]');

    this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.showSlide(this.current - 1));
    this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.showSlide(this.current + 1));
    this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.showSlide(index)));

    this.querySelectorAll('[data-variant-radio]').forEach((radio) => {
      radio.addEventListener('change', () => this.selectVariant(radio.value));
    });
    this.paidSelect?.addEventListener('change', () => this.selectVariant(this.paidSelect.value));
    this.querySelector('[data-sticky-submit]')?.addEventListener('click', () => this.submit?.click());
    this.form?.addEventListener('submit', () => {
      if (this.submit) {
        this.submit.disabled = true;
        this.submit.textContent = this.submit.dataset.loadingText || 'Ajout en cours…';
      }
    });

    if (this.sticky && this.submit) {
      this.observer = new IntersectionObserver(([entry]) => {
        this.sticky.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0 });
      this.observer.observe(this.submit);
    }
  }

  disconnectedCallback() { this.observer?.disconnect(); }

  showSlide(index) {
    if (!this.slides.length) return;
    this.current = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.current));
    this.thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === this.current);
      thumb.setAttribute('aria-current', i === this.current ? 'true' : 'false');
    });
    this.thumbs[this.current]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  selectVariant(id) {
    if (!id || !this.variantInput) return;
    this.variantInput.value = id;
    if (this.paidSelect && this.paidSelect.value !== id) this.paidSelect.value = id;
    const radio = this.querySelector(`[data-variant-radio][value="${CSS.escape(id)}"]`);
    if (radio) radio.checked = true;
    const option = this.paidSelect?.selectedOptions?.[0];
    if (option) {
      const price = option.dataset.price;
      const compare = option.dataset.compare;
      this.querySelectorAll('[data-live-price]').forEach((node) => { if (price) node.textContent = price; });
      this.querySelectorAll('[data-live-compare]').forEach((node) => {
        node.textContent = compare || '';
        node.hidden = !compare;
      });
      const available = option.dataset.available === 'true';
      if (this.submit) {
        this.submit.disabled = !available;
        this.submit.textContent = available ? (this.submit.dataset.defaultText || 'Ajouter au panier') : 'Épuisé';
      }
    }
  }
}

if (!customElements.get('falco-product')) customElements.define('falco-product', FalcoProduct);

document.querySelectorAll('[data-falco-announcement]').forEach((rotator) => {
  const items = [...rotator.querySelectorAll('[data-falco-announcement-item]')];
  if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const interval = Math.max(3000, Number(rotator.dataset.intervalMs) || 3000);
  let activeIndex = 0;
  window.setInterval(() => {
    items[activeIndex].classList.remove('is-active');
    items[activeIndex].setAttribute('aria-hidden', 'true');
    activeIndex = (activeIndex + 1) % items.length;
    items[activeIndex].classList.add('is-active');
    items[activeIndex].setAttribute('aria-hidden', 'false');
  }, interval);
});

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-falco-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-falco-mobile-menu]');
    const open = menu?.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (event.target.closest('[data-falco-backtop]')) window.scrollTo({ top: 0, behavior: 'smooth' });
});

document.querySelectorAll('[data-review-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-review-track]');
  const cards = [...carousel.querySelectorAll('[data-review-card]')];
  let index = 0;
  const paint = () => {
    if (window.matchMedia('(max-width: 749px)').matches && track) track.style.transform = `translateX(-${index * 100}%)`;
  };
  carousel.querySelector('[data-review-prev]')?.addEventListener('click', () => { index = Math.max(0, index - 1); paint(); });
  carousel.querySelector('[data-review-next]')?.addEventListener('click', () => { index = Math.min(cards.length - 1, index + 1); paint(); });
  window.addEventListener('resize', paint, { passive: true });
});

document.body.classList.add('falco-premium-page');

